<div class="modal-container-custom">
  <div class="modal-content-custom listingStyle_1">
    <div class="modal-header">
      <button type="button" class="close" aria-label="Close" id="listing-data-modal-close"
        (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title enabled-text">{{documentNames[documentKey]}}<small> ( Dated: {{listingDate | StringToDateFormatPipe: '': 'default'}} )</small></h4>

    </div>
    <form autocomplete="off" *ngIf="issueListingDataForm" [formGroup]="issueListingDataForm">
      <div class="modal-body dark-section p-6">
        <div class="px-3 pt-4 pb-5 mx-3 text-left">
          Fill up both Opening and Closing dates for all issues below. Note:<br>
          <small>
            1) Opening and Closing Dates should be less than Issue Value Date and within 14 days of Value Date. <br>
            2) Closing Date should be more than Opening Date.
          </small>
        </div>
        <!-- Header Row -->
        <div class="row mt-3 px-3">
          <div class="col-4 text-center info-color listing-header-cell">
            <span>ISIN And Value</span>
          </div>
          <div class="col-4 text-center listing-header-cell">
            <span>
              Opening Date
              <span class="highlight-text">*</span>
            </span>
          </div>
          <div class="col-4 text-center listing-header-cell">
            <span>
              Closing Date
              <span class="highlight-text">*</span>
            </span>
          </div>
        </div>
        <div formArrayName="listed_issues"
          *ngFor="let singleIssue of issueListingDataForm['controls']['listed_issues']['controls']; let i = index;">
          <div class="row px-3" [formGroupName]="i">
            <div class="col-4 listing-detail-cell">
              <div class="text-center resize-height listingStyle_2">
                <small>{{i + 1}}. &nbsp;</small>
                <small id="listing-isin-{{i}}">{{singleIssue.get('isin').value}}</small>
                <small id="listing-isin-{{i}}">&nbsp;( {{singleIssue.get('issue_cap').value | SmartValuePipe: 'INR'}}
                  )</small>
              </div>
            </div>
            <div class="col-4 p-0 listingStyle_3">
              <div class="r-value-box resize-height">
                <input [attr.value]="singleIssue.get('opening_date').value" id="listing-opening-date-{{i}}"
                  class="form-control attachement text-center" [outsideDays]="'collapsed'"
                  placeholder="Select Opening Date" name="listing-opening-date"
                  [minDate]="singleIssue.get('min_date').value" [maxDate]="singleIssue.get('max_date').value"
                  [markDisabled]="isWeekendAndHolidayDisabled" formControlName="opening_date" ngbDatepicker
                  #openingDate="ngbDatepicker" (click)="openingDate.toggle()">
                <div class="input-group-append icons-calender">
                  <button class="btn" (click)="openingDate.toggle()" type="button" id="listing-value-date">
                    <i class="far-i fa fa-calendar"></i>
                  </button>
                </div>
              </div>
              <div class="error-text"
                *ngIf="!singleIssue.get('opening_date').pristine && singleIssue.get('opening_date').errors">
                <small [hidden]="!singleIssue.get('opening_date').errors.required">
                  Opening Date is required.
                </small>
                <small [hidden]="!singleIssue.get('opening_date').errors.ngbDate.invalid">
                  Must be within 14 days of Value Date.
                </small>
              </div>
            </div>
            <div class="col-4 p-0 listingStyle_4">
              <div class="r-value-box resize-height">
                <input [attr.value]="singleIssue.get('closing_date').value" id="listing-closing-date-{{i}}"
                  class="form-control attachement text-center" [outsideDays]="'collapsed'"
                  placeholder="Select Closing Date" name="listing-closing-date"
                  [minDate]="singleIssue.get('opening_date').value || singleIssue.get('min_date').value"
                  [maxDate]="singleIssue.get('max_date').value" [markDisabled]="isWeekendAndHolidayDisabled"
                  formControlName="closing_date" ngbDatepicker #closingDate="ngbDatepicker"
                  (click)="closingDate.toggle()">
                <div class="input-group-append icons-calender">
                  <button class="btn" (click)="closingDate.toggle()" type="button" id="listing-closing-date">
                    <i class="far-i fa fa-calendar"></i>
                  </button>
                </div>
              </div>
              <div class="error-text"
                *ngIf="!singleIssue.get('closing_date').pristine && singleIssue.get('closing_date').errors">
                <small [hidden]="!singleIssue.get('closing_date').errors.required">
                  Opening Date is required.
                </small>
                <small [hidden]="!singleIssue.get('closing_date').errors.ngbDate.invalid">
                  Must be within 14 days of Value Date.
                </small>
                <small [hidden]="!singleIssue.get('closing_date').errors.ngbDate.requiredBefore">
                  Must be more than Opening Date.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <form autocomplete="off" *ngIf="scripCodeForm" [formGroup]="scripCodeForm">
      <div class="modal-body dark-section p-6">
        <div class="px-3 py-4 text-left">Fill up the additional data to generate {{documentNames[documentKey]}}.</div>
        <div class="row px-3">
          <div class="offset-1 col-10 px-4">
            <div class="compt-input">

              <label>Scrip Code
                <span class="highlight-text">*</span>
              </label>
              <div *ngIf="BSEInput" class="r-value-box">
                <input type="text" id="listing-scrip-code" formControlName="under_scrip_code_bse"
                  class="form-control block-box">
                </div>
              <div *ngIf="NSEInput" class="r-value-box">
                  <input *ngIf="NSEInput" type="text" id="listing-scrip-code" formControlName="under_scrip_code_nse"
                  class="form-control block-box">
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="mt-5 modal-footer modal-footer-custom">
      <button type="button" id="listing-extra--data-cancel"
        class="col-md-4 btn btn-outline-normal btn-style-right-1 text-left"
        (click)="activeModal.close()">Cancel</button>
      <button type="submit"
        class="col-md-4 btn btn-md btn-style-right-1 btn-success text-left for-icon-right for-right-arrow"
        id="listing-extra-data-generate" (click)="postListingExtraData()">Generate</button>
    </div>
  </div>
</div>